<template>
    <div>
        <h2 v-if="object" class="mm-link text-center">Inserats-Nummer {{object.id}}</h2>
        <h2 v-html="$t('intern_inserieren.upgrade')"></h2>
        <p v-if="user.user_type === 'gewerblich'" v-html="$t('intern_inserieren.upgrade_decription_gewerblich')"></p>
        <p v-else v-html="$t('intern_inserieren.upgrade_decription')"></p>
        <template v-if="pop_up">
            <b-alert v-model="error" variant="warning" dismissible>
                <div v-html="$t('intern_inserieren.zo_error_msg')"></div>
            </b-alert>
        </template>
        <template v-if="(extensions.length > 0 && ! pop_up)">
            <div class="row" v-for="ext in extensions" :key="ext.id">
                <div class="col-md-9">
                    <div class="form-group">
                        <label class="mm-color">
                            <input type="checkbox" @change="checkDailyWeeklyPushUp(ext.key)" v-model="zusatzleistung[ext.key]">
                            {{ext.title}}
                        </label>
                        <p class="pl-3">{{ext.description}}</p>
                    </div>
                </div>
                <div class="col-md-3 text-right">
                    {{ext.price | currency}}{{$t('intern_inserieren.monat_geld')}}
                </div>
            </div>
        </template>
        <template v-else-if="(extensions.length > 0 && pop_up && used_extensions && applied_extensions)">
            <div class="row" v-for="ext in extensions" :key="ext.key">
                <div class="col-12">
                    <div class="form-group" :class="{'disabled-input': checkIfDisabled(ext.key)}">
                        <label class="mm-color">
                            <input type="checkbox" @change="checkDailyWeeklyPushUp(ext.key)" v-model="zusatzleistung[ext.key]" :disabled="checkIfDisabled(ext.key)">
                            {{ext.title}}
                        </label>
                        <p class="pl-3">{{ext.description}}</p>
                    </div>
                </div>
            </div>
        </template>
        <div class="row" v-if="pop_up">
            <div class="col-12 my-3" v-if="user.user_type != 'gewerblich' && object">
                <router-link :to="{name: 'inserat-booking', params: {object_id: object.id}}" class="btn btn-success">
                    Neue Zusatzoptionen buchen
                </router-link>
            </div>
            <div class="col-12 border-top">
                <div class="mt-3">
                    <button class="btn btn-secondary" @click="$emit('close')">
                        Schließen
                    </button>
                    <button class="btn btn-success float-right" @click="saveImprovement">
                        Speichern
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from '../../../EventBus'
    import Booking  from '../../../classes/Booking';

    export default {
        data() {
            return {
                user: this.$store.state.user,
                object_packets: null,
                //the used extensions of all objects
                used_extensions: null,
                //the applied extensions on the current object
                applied_extensions: null,
                zusatzleistung: {},
                extensions: [],
                tabName: 'IMPROVEMENT',
                error: false
            }
        },
        props: {
            pop_up: {
                default: false
            },
            object: {
                default: null
            },
            extensionsFilter: {
              default: 'all'
            }
        },
        methods: {
            checkIfDisabled(key) {
                return  (
                    this.pop_up
                    &&
                    (
                        (
                            Number(this.used_extensions[key]) >= Number(this.user.packet[key])
                            &&
                            this.user.user_type == 'gewerblich'
                        )
                        ||
                        (
                            this.user.user_type == 'alter_kunde'
                            &&
                            Number(this.used_extensions[key]) >= this.object_packets.filter(item => item.packet_key == key).length
                            &&
                            Number(this.used_extensions[key]) >= Number(this.user.packet[key])
                        )
                        ||
                        (
                            this.user.user_type == 'privat'
                            &&
                            Number(this.used_extensions[key]) >= this.object_packets.filter(item => item.packet_key == key).length
                        )
                    )
                    &&
                    !this.applied_extensions.some(item => item.packet_key == key)
                );
            },
            isChecked(key) {
                return this.applied_extensions.some(item => item.packet_key == key);
            },
            fetchExtensions() {
                this.$store.state.loading = true;
                let url = '/buchungApi/getExtensions';
                if (this.object !== null && this.object.id !== undefined && this.object.id !== 0) {
                  url += '?objectId='+this.object.id
                }

                if (this.extensionsFilter !== null && this.extensionsFilter !== undefined && this.extensionsFilter !== "") {
                  if (url.indexOf('?') > -1) {
                    url += '&extensionsFilter='+this.extensionsFilter
                  } else {
                    url += '&extensionsFilter='+this.extensionsFilter
                  }
                }

                this.$http.get(url).then( response => {
                    let extensions  = JSON.parse(response.data);
                    this.extensions = extensions;
                    this.$store.state.loading = false;
                }).catch( error => {
                    console.log(error);
                });

                if(this.$cookies.isKey('currentBooking') && !this.pop_up){
                    let booking         = Booking.getObjectFromJSON(this.$cookies.get('currentBooking'));
                    this.zusatzleistung = booking.getImprovement();
                }
            },
            checkDailyWeeklyPushUp(key) {
                if(key == "weeklypushup"){
                    if(this.zusatzleistung[key]){
                        this.zusatzleistung['dailypushup'] = false;
                    }
                }else if(key == "dailypushup"){
                    if(this.zusatzleistung[key]){
                        this.zusatzleistung['weeklypushup'] = false;
                    }
                }

                if(this.pop_up){
                    this.$forceUpdate();
                }
            },
            saveImprovement() {
                if(this.pop_up && Object.keys(this.zusatzleistung).length > 0){
                    let improvementObjects = this.extensions.filter(item => this.zusatzleistung[item.key] == true);

                    let data               = {
                        improvementObjects,
                        object_id: this.object.id
                    };

                    this.$http.post('/objectPacketApi/improveObject', data).then(response => {
                        this.$bvToast.toast(response.data, {
                            title: 'Benachrichtigung',
                            autoHideDelay: 1500,
                            variant: 'success'
                        });
                        this.$store.dispatch('OVERVIEW');
                        setTimeout(() => {
                            this.$emit('close');
                        }, 1500);
                    }).catch( error => {
                        this.error = true;
                    });
                }
            },
            weiter(tab) {
                if(tab === this.tabName){
                    let booking            = Booking.getObjectFromJSON(this.$cookies.get('currentBooking'));
                    booking.setImprovement(this.zusatzleistung);

                    let improvementObjects = this.extensions.filter(item => this.zusatzleistung[item.key] == true);
                    booking.setImprovementObjects(improvementObjects);
                    booking.setActiveTab('address');

                    this.$emit('nextTab', booking);
                }
            },
            back(tab) {
                if(tab === this.tabName){
                    this.$emit('moveTo', 'packet_choice');
                }
            }
        },
        created () {
            this.fetchExtensions();
            if(this.pop_up){
                this.object_packets = this.$store.state.object_packets;

                if(!this.object_packets){
                    this.$store.dispatch('OBJECT_PACKETS');
                }
                this.$store.watch(() => {
                    return this.$store.getters.user;
                }, user => {
                    this.user = user;
                });

                this.$store.watch(() => {
                    return this.$store.getters.user;
                }, user => {
                    this.user = user;
                });

                this.$store.state.loading = true;

                this.$http.get('/buchungApi/getUsedExtensions').then( response => {
                    this.used_extensions = JSON.parse(response.data);
                }).catch( error => {
                    console.log(error);
                }).then(() => {
                    this.$http.get('/objectPacketApi/getAllObjectPackets?object_id=' + this.object.id).then( response => {
                        this.applied_extensions = JSON.parse(response.data);

                        for (const ext of this.extensions) {
                            this.zusatzleistung[ext.key] = this.isChecked(ext.key);
                            if(this.zusatzleistung[ext.key] == 'dailypushup' || this.zusatzleistung[ext.key] == 'weeklypushup'){
                                this.checkDailyWeeklyPushUp(ext.key);
                            }
                        }
                    }).catch( error => {
                        console.log(error);
                    })
                }).then( () => {
                    this.$store.state.loading = false;
                });
            }else {
                EventBus.$on('NEXT_EMIT_TO_CHILD', this.weiter);
                EventBus.$on('BACK_EMIT_TO_CHILD', this.back);

                if(this.$cookies.isKey('currentBooking')){
                    let booking         = Booking.getObjectFromJSON(this.$cookies.get('currentBooking'));
                    this.zusatzleistung = booking.getImprovement();
                }
            }
        },
        beforeDestroy () {
            if(!this.pop_up){
                EventBus.$off('NEXT_EMIT_TO_CHILD', this.weiter);
                EventBus.$off('BACK_EMIT_TO_CHILD', this.back);
            }
        },
    }
</script>

<style scoped>
.disabled-input{
    color: #eee !important;
}
.disabled-input .mm-color{
    color: #eee !important;
}
</style>
